import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="card shadow-sm">
                        <div className="card-body p-5">
                            <h1 className="mb-4">Política de Privacidad</h1>
                            <p className="text-muted mb-5">Última actualización: {new Date().toLocaleDateString()}</p>

                            <p>
                                En CUDA, nos tomamos muy en serio su privacidad. Esta política describe cómo recopilamos, usamos y protegemos su información personal.
                            </p>

                            <section className="mb-4">
                                <h4>1. Información Recopilada</h4>
                                <p>
                                    Recopilamos la información que usted nos proporciona directamente al registrarse, como su nombre, correo electrónico y número de teléfono.
                                    También procesamos los mensajes que envía a través de nuestro servicio para proporcionar las respuestas del asistente.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>2. Uso de la Información</h4>
                                <p>
                                    Utilizamos su información para operar, mantener y mejorar nuestro servicio.
                                    No vendemos ni compartimos su información personal con terceros con fines comerciales sin su consentimiento explícito.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>3. Seguridad de los Datos</h4>
                                <p>
                                    Implementamos medidas de seguridad técnicas y organizativas para proteger sus datos personales contra el acceso no autorizado, la alteración o la destrucción.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h4>4. Sus Derechos</h4>
                                <p>
                                    Usted tiene derecho a acceder, corregir o eliminar su información personal.
                                    Puede gestionar su cuenta y datos directamente desde el Dashboard o contactando a soporte para su eliminación total.
                                </p>
                            </section>

                             <section className="mb-4">
                                <h4>5. Uso de datos de los servicios de API de Google</h4>
                                <p>
                                    El uso y la transferencia por parte de CUDA de la información recibida de las API de Google a cualquier otra aplicación se ajustarán a la Política de Datos del Usuario de los Servicios de las API de Google, incluidos los requisitos de Uso Limitado.
                                </p>
                            </section>

                            <div className="mt-5 text-center">
                                <Link to="/register" className="btn btn-primary">Volver al Registro</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPage;
